import ChoiceColor from './choice-color'

export default ChoiceColor;